<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 80vh">
      <template>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="filters.name"
              label="Nombre"
              outlined
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <!--Inicio médico-->
        <v-row class="pl-3 pr-3">
          <v-col cols="11" class="pb-3" v-if="filters.doctor == null">
            <v-autocomplete
              :value="filters.doctor_id"
              :items="doctors"
              label="Médico"
              hide-details
              outlined
              :item-text="customTextDoctor"
              item-value="id"
              clearable
              @change="handleSelectDoctor"
              :filter="customFilter"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.fullname
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    DNI: {{ data.item.document }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
          <!-- <v-col cols="1" class="pl-0" v-if="doctor == null">
            <v-icon
              color="success"
              class="mt-2"
              @click="handleViewCreateDoctor"
            >
              fas fa-plus-circle
            </v-icon>
          </v-col> -->
        </v-row>

        <v-row class="pl-3 pr-3" v-if="filters.doctor">
          <v-col cols="12" class="pt-0 pb-0">
            <v-list two-line class="pt-0 pb-0">
              <v-list-item class="pl-1 pr-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="green" class="mr-2" size="18">
                      fas fa-user-tag
                    </v-icon>
                    <span
                      class="
                        text-uppercase
                        font-weight-bold
                        cart-label-customer
                      "
                      >{{ filters.doctor.fullname }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="ml-8">DNI: {{ filters.doctor.document }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="handleClearDoctor" color="red">
                    <v-icon>far fa-times-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <!--Fin médico-->
        <!-- <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="filters.description"
              outlined
              label="Descripción"
            >
            </v-textarea>
          </v-col>
        </v-row> -->
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn
              block
              height="40"
              dark
              color="red"
              @click="handleClearFilters"
            >
              <v-icon size="16" class="mr-1">far fa-trash-alt</v-icon>
              Quitar filtros
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn dark color="blue" block height="40" @click="handleSearch">
              <v-icon size="16" class="mr-1">fas fa-search</v-icon>
              Filtrar datos
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ArrayTools from "../../helpers/ArrayTools";

export default {
  name: "Filters",
  data() {
    return {
      drawer: false,
      titleForm: null,
      filters: {
        name: null,
        description: null,
        doctor: null,
        doctor_id: null,
      },
    };
  },
  computed: {
    ...mapState("doctors", ["doctors"]),
  },
  methods: {
    ...mapActions("brands", ["getBrands"]),
    ...mapActions("doctors", ["getDoctors"]),
    customTextDoctor(item) {
      let text = item.fullname;

      return text;
    },
    showForm(title) {
      this.titleForm = title;
      this.drawer = !this.drawer;
    },
    closeForm() {
      this.drawer = false;
    },
    clearData() {
      this.filters.name = null;
      this.filters.description = null;
    },
    customText(item) {
      let text = item.name;

      return text;
    },
    async handleClearFilters() {
      this.clearData();
      await this.getBrands(this.filters);
    },
    async handleSearch() {
      await this.getBrands(this.filters);
      this.closeForm();
    },
    handleSelectDoctor(value) {
      if (value == null || value == undefined) {
        this.filters.doctor = null;
      } else {
        let selected_doctor = ArrayTools.getElementById(this.doctors, value);
        this.filters.doctor = selected_doctor;
        this.filters.doctor_id = selected_doctor.id;
      }
    },
    customFilter(item, queryText, itemText) {
      // console.log(item);
      let textName = "";
      if (item.name) {
        if (item.fullname) {
          textName = item.fullname.toLowerCase();
        } else {
          textName = item.name.toLowerCase();
        }
      }
      let textDocument = "";
      if (item.document) {
        textDocument = item.document.toLowerCase();
      }
      let searchText = queryText.toLowerCase();

      return (
        textName.indexOf(searchText) > -1 ||
        textDocument.indexOf(searchText) > -1
      );
    },
    handleClearDoctor() {
      this.filters.doctor = null;
      this.filters.doctor_id = null;
    },
  },
  created() {
    this.getDoctors();
  },
};
</script>

<style scoped></style>
